export default __webpack_public_path__ + "assets/images/done-changing-cards-icon.154348dc1a447b24cb7dc2a131f2389a.svg";